import * as React from 'react';
import { ButtonAnchor as DSButton, ButtonSize, ButtonVariant, Icon, IconName, IconRotation } from '@/components/shared';
import { ButtonComponentProps } from './register';

type ButtonProps = ButtonComponentProps<ButtonVariant, ButtonSize> & {
	readonly iconBefore?: IconName;
	readonly iconAfter?: IconName;
	readonly ariaLabel?: string;
	readonly rotateIcon?: IconRotation;
};

/**
 * CMS Button component, used for creating buttons. It overrides Builder's default
 * button component extending it with props coming from the Design System.
 * */
export const Button: React.FunctionComponent<ButtonProps> = ({
	text,
	link,
	openInNewTab,
	variant,
	size,
	iconBefore,
	iconAfter,
	ariaLabel,
	rotateIcon,
}) => {
	return (
		<DSButton
			size={size || undefined}
			variant={variant || 'secondary'}
			href={link ? link : undefined}
			target={openInNewTab ? '_blank' : undefined}
			hasOnlyIcon={Boolean((iconBefore || iconAfter) && !text)}
			aria-label={ariaLabel ?? text ?? ''}
		>
			{iconBefore && <Icon name={iconBefore} size={'md'} rotate={rotateIcon} />}
			{text}
			{iconAfter && <Icon name={iconAfter} size={'md'} rotate={rotateIcon} />}
		</DSButton>
	);
};
